import type { Observable } from 'rxjs';

import type { Location } from '@core/locations-types';

export enum SelectMode {
  Single = 'single',
  Multi = 'multi',
}

export enum SortOption {
  Name = 'name',
  Country = 'country',
  State = 'state',
  City = 'city',
}

export const SortKey = {
  [SortOption.Name]: SortOption.Name,
  [SortOption.Country]: 'countryCode',
  [SortOption.State]: 'stateName',
  [SortOption.City]: SortOption.City,
};

export enum TemplateKind {
  Default = 'default',
  Group = 'group',
}

export type TemplateGroup = {
  title: string;
  locations: LocationItem[];
  kind: TemplateKind.Group | TemplateKind.Default;
  key?: string;
};

export type SortOptionsType =
  | SortOption.Name
  | SortOption.Country
  | SortOption.State
  | SortOption.City;

export type DialogData = {
  initialAssignedLocationIds: number[];
  assignedLocationIds?: number[];
  selectMode: SelectMode;
  heading?: string;
  subheading?: string;
  submitLabel?: string;
  locationSlotsNumber?: number;
  hasAddNewLocation?: boolean;
  hasGoToSettings?: boolean;
  availableLocationIds?: number[];
  isAlwaysSaveable?: boolean;
  hasSkip?: boolean;
  companyId?: number;
  addNewLocationHandler$?: (assignedLocationIds: number[]) => void;
  saveHandler$?: (assignedLocationIds: number[]) => Observable<boolean>;
  goBackHandler?: () => void;
  hideInvalidLocations?: boolean;
};

export type LocationItem = Pick<
  Location,
  'id' | 'name' | 'fullAddress' | 'countryCode' | 'stateName' | 'city' | 'isValid'
> & {
  isArchived: boolean;
  isRemoved: boolean;
};
